import * as _ from "lodash";
import * as React from "react";
import {AppConstants} from "../../../utils/AppConstants";

export interface DiagnosticAssessmentPlanPDFProps {
    id: string;
    planItem: any;
}

const DiagnosticAssessmentPlanPDFTemplate: React.StatelessComponent<DiagnosticAssessmentPlanPDFProps> = (props: DiagnosticAssessmentPlanPDFProps) => {
    let id = props.id;
    let planItem = props.planItem;
    let itemsToIterate = planItem[id];
    return (
        <div id={id} className={`prescription-grid-row external-row`}>
            <div className="prescription-card-content">
                <div className={`${id}-header brandon-bold`}><img src="/images/icons/lab-test-header-icon.svg" className={"header-icon"} /> LAB TESTS</div>
                <div id={`${id}-subsection`} className="prescription-description">
                    <ul>
                        {_.map(itemsToIterate, (diagnostic, index) => {
                            const repetitionCount = !_.isEmpty(diagnostic.diagnosticsDuration) && diagnostic.diagnosticsDuration.count && diagnostic.diagnosticsDuration.count > 1 ? diagnostic.diagnosticsDuration.count : "";
                            return <div key={`${diagnostic}-${index}`} className={"diagnostic-item"}>
                                <li>
                                    <div className={"diagnostic-activity-name brandon-bold"}>{diagnostic.diagnosticTest.displayValue}</div>
                                    <div className={"activity-frequency"}>
                                        {
                                            !_.isEmpty(diagnostic.medicineFrequency) && diagnostic.medicineFrequency !== undefined && diagnostic.medicineFrequency !== "" &&
                                            !_.isEmpty(diagnostic.medicineFrequency) && !_.isEmpty(diagnostic.medicineFrequency.unit) &&
                                            <span className="prescription-description">{`${diagnostic.medicineFrequency.count} times /${repetitionCount} ${AppConstants.FrequencyUnit[diagnostic.medicineFrequency.unit]}`}</span>
                                        }
                                    </div>
                                </li>
                            </div>
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default DiagnosticAssessmentPlanPDFTemplate;